import { render, staticRenderFns } from "./WhatsappRodapeList.vue?vue&type=template&id=4da99d8d"
import script from "./WhatsappRodapeList.vue?vue&type=script&lang=js"
export * from "./WhatsappRodapeList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappRodapeList.vue?vue&type=style&index=0&id=4da99d8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports